import React from "react";
import PropTypes from "prop-types";
import CmsVideoText from "@/bit/components/components.cms-block.cms-video-text";
import TextInfo from "@/bit/components/components.text";
import emptyMock from "./emptyMock.json";
import getColor from "@gcloud-npm/utils.enums.colors";

const CmsVideoTextList = (props) => {
  const {
    cmsHandler = null,
    blockName,
    alias,
    CmsAddElement,
    CmsEditableGroupIcons,
    dotNotation,
  } = props;

  const titleProps = props["cms-atom-text-1"];
  const videoTextList = props["cms-ml-video-text-list-1"];

  const color = props.color || "white";
  const backgroundColor = getColor(color);

  if (
    !videoTextList ||
    !Array.isArray(videoTextList) ||
    (videoTextList.length === 0 && !dotNotation)
  ) {
    return null;
  }

  // Add Element Props
  const addProps = {
    contentId: blockName,
    itemIdDotNotation: `${blockName}.cms-ml-video-text-list-1`,
    layout: "vertical",
  };

  return (
    <section
      id={blockName || ""}
      className={`container video-text-module`}
      style={{ backgroundColor: backgroundColor }}
    >
      {CmsEditableGroupIcons && (
        <CmsEditableGroupIcons
          noCustomLink
          elementProps={{
            ...props,
            editName: "cms-block.cms-video-text-list",
          }}
          deleteProps={{}}
          visibleTools={{
            hiring: false,
            edit: true,
            deleteItem: false,
          }}
          cmsHandler={cmsHandler}
        />
      )}
      {/* TITULO */}
      {titleProps && (
        <TextInfo
          {...titleProps}
          kind="h"
          level="2"
          className="text--title"
          cmsHandler={cmsHandler}
        />
      )}
      {/* AÑADIR ELEMENTO */}
      {CmsAddElement && (
        <CmsAddElement
          addProps={{
            index: "start",
            ...addProps,
          }}
          cmsHandler={cmsHandler}
        />
      )}
      {/* LISTA DE ELEMENTOS */}
      <div className="video-text-module__items">
        {videoTextList.length === 0 ? (
          <CmsVideoText {...emptyMock} />
        ) : (
          videoTextList.map((row, index) => (
            <CmsVideoText
              {...row}
              key={`cms-video-text-${index}`}
              index={index}
              blockName={blockName}
              alias={alias}
              CmsEditableGroupIcons={CmsEditableGroupIcons}
              frontalListToDelete={videoTextList}
              cmsHandler={cmsHandler}
            />
          ))
        )}{" "}
      </div>
      {/* AÑADIR ELEMENTO */}
      {CmsAddElement && (
        <CmsAddElement
          addProps={{
            index: "end",
            ...addProps,
          }}
          cmsHandler={cmsHandler}
        />
      )}
      <style jsx>{`.video-text-module {
  border-radius: 16px;
  padding: 2rem !important;
  margin-top: 1.5rem;

  :global(.text--title) {
    padding-bottom: 2rem;
  }

  &__items {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
}
`}</style>
    </section>
  );
};

export default CmsVideoTextList;

CmsVideoTextList.propTypes = {
  /**
   * {
   *  "info": "Color de fondo",
   *  "kind": "both",
   *  "beautifulName": "Color de fondo"
   * }
   */
  color: PropTypes.string,
};

CmsVideoTextList.defaultProps = {
  color: "",
};
